import customDialog from './customDialog.vue'
const customDialogOp = {
  install: (Vue) => {
    Vue.component(customDialog.name, customDialog)
  }
}
export default customDialogOp

